import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

// Verifica se a biblioteca jspdf-autotable foi carregada corretamente
console.log("jsPDF:", jsPDF);
console.log("autoTable:", autoTable);

export class ExportGrid {
    static pdf (mygrid) {
        mygrid.toPDF('https://pdf.rastreamos.app/pdf/generate.php',null,false,false);
    }

    static excel (mygrid) {
        mygrid.toExcel('https://pdf.rastreamos.app/excel/generatehtml.php',null,false,false);
        //mygrid.toExcel('https://dhtmlxgrid.appspot.com/export/excel',null,false,false);
    }

    static excel2 (mygrid) {
        mygrid.export.xlsx({
            url: 'https://export.dhtmlx.com/excel'
        });
    }

    static pdf2 (mygrid) {
        let url = 'https://export.dhtmlx.com'; //  change to your local host if you need

        mygrid.export.pdf({
            url: `${url}/grid/pdf/8.1`,
            pdf: {
                format: 'A4',
                scale: 0.70,
                landscape: true,
                displayHeaderFooter: false,
                printBackground: false
            },
            theme: 'light',
        });
    }

    static excelFormatado(mygrid, titulo = 'Relatório de Veículos') {
        mygrid.export.xlsx({
            url: 'https://export.dhtmlx.com/excel',
            name: titulo,
            styles: {
                header: {
                    background: '#4CAF50',
                    color: '#FFFFFF',
                    fontSize: 14,
                    fontWeight: 'bold',
                    textAlign: 'center',
                    border: {
                        top: { style: 'thin', color: '#000000' },
                        bottom: { style: 'thin', color: '#000000' },
                        left: { style: 'thin', color: '#000000' },
                        right: { style: 'thin', color: '#000000' }
                    }
                },
                cells: {
                    background: '#FFFFFF',
                    color: '#000000',
                    fontSize: 12,
                    border: {
                        top: { style: 'thin', color: '#CCCCCC' },
                        bottom: { style: 'thin', color: '#CCCCCC' },
                        left: { style: 'thin', color: '#CCCCCC' },
                        right: { style: 'thin', color: '#CCCCCC' }
                    }
                },
                alternateRows: {
                    background: '#F5F5F5'
                }
            },
            header: {
                height: 30,
                textAlign: 'center',
                verticalAlign: 'middle'
            },
            columns: {
                autoWidth: true,
                minWidth: 100
            },
            freeze: {
                rows: 1
            }
        });
    }

    static excelLocal(mygrid, titulo = 'Relatório de Veículos') {
        try {
            // Obtém os dados da grid
            const dados = mygrid.data.serialize();
            const colunas = mygrid.config.columns.filter(col => !col.hidden);
            
            // Prepara os cabeçalhos
            const headers = colunas.map(col => col.header[0].text);
            
            // Prepara os dados com formatação aprimorada
            const dadosFormatados = dados.map(row => {
                return colunas.map(col => {
                    let valor = row[col.id];
                    
                    // Formatação específica para diferentes tipos de dados
                    if (valor instanceof Date) {
                        valor = valor.toLocaleDateString('pt-BR');
                    } else if (typeof valor === 'number') {
                        // Formatação para números (se for moeda ou percentual)
                        if (col.id.toLowerCase().includes('valor') || col.id.toLowerCase().includes('preco')) {
                            valor = new Intl.NumberFormat('pt-BR', { 
                                style: 'currency', 
                                currency: 'BRL' 
                            }).format(valor);
                        } else if (col.id.toLowerCase().includes('percent')) {
                            valor = new Intl.NumberFormat('pt-BR', { 
                                style: 'percent' 
                            }).format(valor / 100);
                        }
                    } else if (valor === null || valor === undefined) {
                        valor = '';
                    }
                    
                    return valor;
                });
            });

            // Cria dados com cabeçalho do relatório
            const dataAtual = new Date().toLocaleDateString('pt-BR', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            });

            // Estrutura completa da planilha com cabeçalho personalizado
            const dadosCompletos = [
                [titulo], // Linha do título principal
                [`Gerado em: ${dataAtual}`], // Linha da data
                [''], // Linha vazia para espaçamento
                headers, // Cabeçalhos das colunas
                ...dadosFormatados // Dados da tabela
            ];

            // Cria a planilha
            const ws = XLSX.utils.aoa_to_sheet(dadosCompletos);
            const range = XLSX.utils.decode_range(ws['!ref']);

            // === FORMATAÇÃO DO TÍTULO PRINCIPAL ===
            const tituloCell = XLSX.utils.encode_cell({r: 0, c: 0});
            if (ws[tituloCell]) {
                ws[tituloCell].s = {
                    fill: { fgColor: { rgb: "1565C0" } }, // Azul profissional
                    font: { 
                        color: { rgb: "FFFFFF" }, 
                        bold: true, 
                        sz: 18,
                        name: "Calibri"
                    },
                    alignment: { 
                        horizontal: "center", 
                        vertical: "center" 
                    },
                    border: {
                        top: { style: "thick", color: { rgb: "0D47A1" } },
                        bottom: { style: "thick", color: { rgb: "0D47A1" } },
                        left: { style: "thick", color: { rgb: "0D47A1" } },
                        right: { style: "thick", color: { rgb: "0D47A1" } }
                    }
                };
            }

            // Mescla células do título
            ws['!merges'] = [{
                s: { c: 0, r: 0 },
                e: { c: range.e.c, r: 0 }
            }];

            // === FORMATAÇÃO DA DATA ===
            const dataCell = XLSX.utils.encode_cell({r: 1, c: 0});
            if (ws[dataCell]) {
                ws[dataCell].s = {
                    fill: { fgColor: { rgb: "E3F2FD" } }, // Azul claro
                    font: { 
                        color: { rgb: "1565C0" }, 
                        italic: true, 
                        sz: 12,
                        name: "Calibri"
                    },
                    alignment: { 
                        horizontal: "center", 
                        vertical: "center" 
                    },
                    border: {
                        top: { style: "thin", color: { rgb: "1565C0" } },
                        bottom: { style: "thin", color: { rgb: "1565C0" } },
                        left: { style: "thin", color: { rgb: "1565C0" } },
                        right: { style: "thin", color: { rgb: "1565C0" } }
                    }
                };
            }

            // Mescla células da data
            ws['!merges'].push({
                s: { c: 0, r: 1 },
                e: { c: range.e.c, r: 1 }
            });

            // === FORMATAÇÃO DOS CABEÇALHOS ===
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const address = XLSX.utils.encode_cell({r: 3, c: C});
                if (!ws[address]) continue;
                
                ws[address].s = {
                    fill: { fgColor: { rgb: "616161" } }, // Cinza mediano
                    font: { 
                        color: { rgb: "FFFFFF" }, 
                        bold: true, 
                        sz: 12,
                        name: "Calibri"
                    },
                    alignment: { 
                        horizontal: "center", 
                        vertical: "center",
                        wrapText: true
                    },
                    border: {
                        top: { style: "medium", color: { rgb: "424242" } },
                        bottom: { style: "medium", color: { rgb: "424242" } },
                        left: { style: "thin", color: { rgb: "424242" } },
                        right: { style: "thin", color: { rgb: "424242" } }
                    }
                };
            }

            // === FORMATAÇÃO DAS CÉLULAS DE DADOS ===
            for (let R = 4; R <= range.e.r; ++R) {
                const isEvenRow = (R - 4) % 2 === 0;
                
                for (let C = range.s.c; C <= range.e.c; ++C) {
                    const address = XLSX.utils.encode_cell({r: R, c: C});
                    if (!ws[address]) continue;
                    
                    // Detecta tipo de coluna para formatação específica
                    const colId = (colunas[C] && colunas[C].id && colunas[C].id.toLowerCase()) || '';
                    let cellStyle = {
                        fill: { fgColor: { rgb: isEvenRow ? "FFFFFF" : "F8F9FA" } },
                        font: { 
                            sz: 11,
                            name: "Calibri",
                            color: { rgb: "212121" }
                        },
                        alignment: { 
                            horizontal: "center", 
                            vertical: "center" 
                        },
                        border: {
                            top: { style: "thin", color: { rgb: "E0E0E0" } },
                            bottom: { style: "thin", color: { rgb: "E0E0E0" } },
                            left: { style: "thin", color: { rgb: "E0E0E0" } },
                            right: { style: "thin", color: { rgb: "E0E0E0" } }
                        }
                    };

                                         // Formatação especial para diferentes tipos de dados
                     if (colId.includes('status')) {
                         const valor = (ws[address].v && ws[address].v.toString().toLowerCase()) || '';
                         if (valor === 'ativo' || valor === 'online') {
                            cellStyle.fill = { fgColor: { rgb: "C8E6C9" } }; // Verde claro
                            cellStyle.font.color = { rgb: "2E7D32" };
                            cellStyle.font.bold = true;
                        } else if (valor === 'inativo' || valor === 'offline') {
                            cellStyle.fill = { fgColor: { rgb: "FFCDD2" } }; // Vermelho claro
                            cellStyle.font.color = { rgb: "C62828" };
                            cellStyle.font.bold = true;
                        }
                    } else if (colId.includes('valor') || colId.includes('preco')) {
                        cellStyle.alignment.horizontal = "right";
                        cellStyle.font.color = { rgb: "1976D2" };
                        cellStyle.font.bold = true;
                    } else if (colId.includes('data') || colId.includes('hora')) {
                        cellStyle.font.color = { rgb: "5D4037" };
                    }

                    ws[address].s = cellStyle;
                }
            }

            // === CONFIGURAÇÃO AVANÇADA DE COLUNAS ===
            const wscols = colunas.map((col, index) => {
                let width = 15; // Largura padrão
                
                                 // Ajusta largura baseada no tipo de coluna
                 const colId = (col.id && col.id.toLowerCase()) || '';
                 if (colId.includes('id')) {
                    width = 8;
                } else if (colId.includes('nome') || colId.includes('descricao')) {
                    width = 25;
                } else if (colId.includes('data') || colId.includes('hora')) {
                    width = 18;
                } else if (colId.includes('status')) {
                    width = 12;
                } else if (colId.includes('valor') || colId.includes('preco')) {
                    width = 15;
                } else if (col.width) {
                    width = Math.max(col.width / 8, 10);
                }
                
                return { wch: width };
            });
            
            ws['!cols'] = wscols;

            // === CONFIGURAÇÕES ADICIONAIS DA PLANILHA ===
            // Congela a primeira linha de dados (após o cabeçalho)
            ws['!freeze'] = { xSplit: 0, ySplit: 4 };
            
            // Define filtros automáticos
            ws['!autofilter'] = {
                ref: XLSX.utils.encode_range({
                    s: { c: 0, r: 3 },
                    e: { c: range.e.c, r: range.e.r }
                })
            };

            // Altura das linhas
            ws['!rows'] = [
                { hpt: 35 }, // Linha do título
                { hpt: 25 }, // Linha da data
                { hpt: 15 }, // Linha vazia
                { hpt: 30 }, // Cabeçalhos
                ...Array(dadosFormatados.length).fill({ hpt: 20 }) // Dados
            ];

            // === CRIAÇÃO DO WORKBOOK ===
            const wb = XLSX.utils.book_new();
            
            // Propriedades do documento
            wb.Props = {
                Title: titulo,
                Subject: "Relatório de Rastreamento Veicular",
                Author: "Sistema Rastreamos",
                CreatedDate: new Date(),
                Company: "Rastreamos"
            };
            
            // Adiciona a planilha com nome personalizado
            const sheetName = titulo.length > 31 ? titulo.substring(0, 28) + "..." : titulo;
            XLSX.utils.book_append_sheet(wb, ws, sheetName);

            // === GERAÇÃO E DOWNLOAD ===
            const wbout = XLSX.write(wb, { 
                bookType: 'xlsx', 
                type: 'array',
                bookSST: false,
                compression: true
            });
            
            // Converte para base64
            const bytes = new Uint8Array(wbout);
            let binary = '';
            for (let i = 0; i < bytes.byteLength; i++) {
                binary += String.fromCharCode(bytes[i]);
            }
            const base64 = btoa(binary);
            
            // Cria o link de download
            const link = document.createElement('a');
            link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${base64}`;
            link.download = `${titulo}_${new Date().toISOString().split('T')[0]}.xlsx`;
            
            // Executa o download
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            console.log(`✅ Excel exportado com sucesso: ${titulo}`);
            return true;
            
        } catch (error) {
            console.error("❌ Erro ao exportar para Excel:", error);
            return false;
        }
    }

    static csvLocal(mygrid, titulo = 'Relatório de Veículos') {
        try {
            // Obtém os dados da grid
            const dados = mygrid.data.serialize();
            const colunas = mygrid.config.columns.filter(col => !col.hidden);
            
            // Prepara os cabeçalhos
            const headers = colunas.map(col => col.header[0].text);
            
            // Prepara os dados
            const dadosFormatados = dados.map(row => {
                return colunas.map(col => {
                    let valor = row[col.id];
                    // Formatação específica para datas
                    if (valor instanceof Date) {
                        valor = valor.toLocaleDateString('pt-BR');
                    }
                    // Escapa aspas duplas e envolve em aspas se contiver vírgula
                    if (typeof valor === 'string') {
                        valor = valor.replace(/"/g, '""');
                        if (valor.includes(',') || valor.includes('"') || valor.includes('\n')) {
                            valor = `"${valor}"`;
                        }
                    }
                    return valor;
                });
            });

            // Converte para CSV
            const csvContent = [
                headers.join(','),
                ...dadosFormatados.map(row => row.join(','))
            ].join('\n');

            // Cria um link de download
            const link = document.createElement('a');
            link.href = `data:text/csv;charset=utf-8,${encodeURIComponent(csvContent)}`;
            link.download = `${titulo}.csv`;
            
            // Adiciona o link ao documento, clica nele e remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            return true;
        } catch (error) {
            console.error("Erro ao exportar para CSV:", error);
            return false;
        }
    }

    static pdfLocal(mygrid, titulo = 'Relatório de Veículos') {
        try {
            console.log("Iniciando exportação para PDF...");
            
            // Verifica se a grid é válida
            if (!mygrid || !mygrid.data) {
                console.error("Grid inválida ou sem dados");
                return false;
            }
            
            // Obtém os dados da grid
            const dados = mygrid.data.serialize();
            console.log("Dados obtidos da grid:", dados);
            
            // Verifica se há dados
            if (!dados || dados.length === 0) {
                console.error("Nenhum dado encontrado na grid");
                return false;
            }
            
            // Filtra as colunas visíveis
            const colunas = mygrid.config.columns.filter(col => !col.hidden);
            console.log("Colunas visíveis:", colunas);
            
            // Verifica se há colunas
            if (!colunas || colunas.length === 0) {
                console.error("Nenhuma coluna visível encontrada");
                return false;
            }
            
            // Prepara os cabeçalhos
            const headers = colunas.map(col => col.header[0].text);
            console.log("Cabeçalhos:", headers);
            
            // Prepara os dados
            const dadosFormatados = dados.map(row => {
                return colunas.map(col => {
                    let valor = row[col.id];
                    // Formatação específica para datas
                    if (valor instanceof Date) {
                        valor = valor.toLocaleDateString('pt-BR');
                    }
                    // Converte para string se não for
                    if (valor !== null && valor !== undefined) {
                        valor = String(valor);
                    } else {
                        valor = '';
                    }
                    return valor;
                });
            });
            console.log("Dados formatados:", dadosFormatados);

            // Cria o documento PDF
            const doc = new jsPDF({
                orientation: 'landscape',
                unit: 'mm',
                format: 'a4'
            });

            // Adiciona um cabeçalho personalizado
            doc.setFillColor(41, 128, 185); // Azul
            doc.rect(0, 0, doc.internal.pageSize.width, 25, 'F');
            
            // Adiciona o título
            doc.setTextColor(255, 255, 255);
            doc.setFontSize(20);
            doc.setFont('helvetica', 'bold');
            doc.text(titulo, 14, 15);
            
            // Adiciona a data de geração
            doc.setFontSize(10);
            doc.setFont('helvetica', 'normal');
            const dataAtual = new Date().toLocaleDateString('pt-BR');
            doc.text(`Gerado em: ${dataAtual}`, 14, 22);

            // Calcula a largura disponível para a tabela (em mm)
            const pageWidth = doc.internal.pageSize.width;
            const margin = 5; // margem esquerda e direita reduzida drasticamente para 5mm
            const availableWidth = pageWidth - (2 * margin);
            
            // Calcula a largura proporcional para cada coluna com base no conteúdo
            const columnWidths = {};
            
            // Calcula a largura mínima necessária para cada coluna com base no conteúdo
            const minWidths = {};
            
            // Função para estimar a largura do texto em mm
            const getTextWidth = (text, fontSize) => {
                if (!text) return 0;
                const textStr = String(text);
                // Estimativa aproximada: cada caractere ocupa ~0.5mm com fonte de tamanho 9
                return textStr.length * 0.5 * (fontSize / 9);
            };
            
            // Calcula a largura mínima para cada coluna com base nos cabeçalhos e dados
            headers.forEach((header, index) => {
                // Largura mínima para o cabeçalho
                const headerWidth = getTextWidth(header, 10);
                
                // Largura mínima para os dados
                let maxDataWidth = 0;
                dadosFormatados.forEach(row => {
                    const dataWidth = getTextWidth(row[index], 9);
                    maxDataWidth = Math.max(maxDataWidth, dataWidth);
                });
                
                // Largura mínima total para a coluna
                minWidths[index] = Math.max(headerWidth, maxDataWidth, 15); // Mínimo de 15mm
            });
            
            // Calcula a soma das larguras mínimas
            const totalMinWidth = Object.values(minWidths).reduce((sum, width) => sum + width, 0);
            
            // Se a soma das larguras mínimas for maior que a largura disponível, ajusta proporcionalmente
            if (totalMinWidth > availableWidth) {
                const ratio = availableWidth / totalMinWidth;
                Object.keys(minWidths).forEach(index => {
                    columnWidths[index] = minWidths[index] * ratio;
                });
            } else {
                // Caso contrário, usa as larguras mínimas
                Object.keys(minWidths).forEach(index => {
                    columnWidths[index] = minWidths[index];
                });
            }

            console.log("Configuração da tabela:", {
                headers,
                dadosFormatados: dadosFormatados.length > 0 ? dadosFormatados[0] : [],
                columnWidths
            });

            // Adiciona a tabela usando a biblioteca autoTable
            autoTable(doc, {
                head: [headers],
                body: dadosFormatados,
                startY: 30,
                theme: 'grid',
                styles: {
                    fontSize: 9,
                    cellPadding: { top: 2, right: 1, bottom: 2, left: 1 }, // Padding reduzido ao mínimo
                    overflow: 'linebreak',
                    halign: 'center',
                    valign: 'middle',
                    lineColor: [200, 200, 200],
                    lineWidth: 0.1
                },
                headStyles: {
                    fillColor: [41, 128, 185], // Azul
                    textColor: [255, 255, 255],
                    fontSize: 10,
                    fontStyle: 'bold',
                    halign: 'center',
                    valign: 'middle'
                },
                alternateRowStyles: {
                    fillColor: [245, 245, 245]
                },
                columnStyles: columnWidths,
                margin: { top: 30, right: margin, bottom: 20, left: margin },
                didDrawPage: function(data) {
                    // Adiciona o rodapé em cada página
                    const pageCount = doc.internal.getNumberOfPages();
                    const pageHeight = doc.internal.pageSize.height;
                    
                    // Adiciona uma linha divisória
                    doc.setDrawColor(200, 200, 200);
                    doc.line(margin, pageHeight - 15, pageWidth - margin, pageHeight - 15);
                    
                    // Adiciona o número da página
                    doc.setFontSize(8);
                    doc.setTextColor(100, 100, 100);
                    doc.text(
                        'Página ' + pageCount + ' de ' + pageCount,
                        pageWidth - margin - 20,
                        pageHeight - 10
                    );
                    
                    // Adiciona o nome da empresa
                    doc.text(
                        'Rastreamento Veicular',
                        margin,
                        pageHeight - 10
                    );
                }
            });

            // Gera o PDF como uma string base64
            const pdfBase64 = doc.output('datauristring');
            
            // Cria um link de download
            const link = document.createElement('a');
            link.href = pdfBase64;
            link.download = `${titulo}.pdf`;
            
            // Adiciona o link ao documento, clica nele e remove
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            
            console.log("PDF gerado com sucesso!");
            return true;
        } catch (error) {
            console.error("Erro ao exportar para PDF:", error);
            return false;
        }
    }
}
